module.exports = __webpack_public_path__ + "media/24.3203f7e4.mp3";